import React from "react";
import Button from "@material-ui/core/Button";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import { Grid } from "@material-ui/core";
import { CSVLink } from "react-csv";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import "dayjs/locale/ja";
import dayjs from "dayjs";
dayjs.locale("ja");

export default function DataDownloads(props) {
  const handleRankingData = () => {
    const keywordsCsv = buildCsvData(props.keywords, function (data) {
      return data.word;
    });
    const retweetsCsv = buildCsvData(props.retweets, function (data) {
      return data.tweet.text.replace(/\r?\n/g, "");
    });
    const usersCsv = buildCsvData(props.users, function (data) {
      return data.user_name;
    });

    let zip = new JSZip();
    zip.file("topic_ranking.csv", retweetsCsv);
    zip.file("keyword_ranking.csv", keywordsCsv);
    zip.file("user_ranking.csv", usersCsv);

    const min_time_id = dayjs(props.from).format("YYYYMMDD");
    const max_time_id = dayjs(props.to).format("YYYYMMDD");
    const fileName =
      props.group?.name +
      "_ランキングデータ_" +
      min_time_id +
      "-" +
      max_time_id +
      ".zip";
    zip.generateAsync({ type: "blob" }).then((blob) => {
      saveAs(blob, fileName);
    });
  };

  const buildCsvData = (data, bodyFunc) => {
    let csv = "";
    for (let i = 0; i < data.length; i++) {
      csv += data[i].count + "," + '"' + bodyFunc(data[i]) + '"';
      csv += "\n";
    }
    const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
    const blob = new Blob([bom, csv], { type: "text/csv" });
    return blob;
  };

  return (
    <Grid container spacing={2} justifyContent="flex-end">
      <Grid>
        <Button
          variant="contained"
          color="primary"
          size="small"
          startIcon={<CloudDownloadIcon />}
        >
          <CSVLink
            data={props.tweets}
            filename={`${props.group?.name}_グラフデータ_${dayjs(
              props.from
            ).format("YYYYMMDD")}-${dayjs(props.to).format("YYYYMMDD")}.csv`}
            style={{ color: "#FFF", textDecoration: "none" }}
          >
            グラフデータ
          </CSVLink>
        </Button>
      </Grid>
      <Grid>
        <Button
          variant="contained"
          color="primary"
          size="small"
          startIcon={<CloudDownloadIcon />}
          onClick={handleRankingData}
        >
          ランキングデータ
        </Button>
      </Grid>
    </Grid>
  );
}
